exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification{position:absolute;left:-7px;top:-7px;width:24px;height:24px;background-color:#ab2b7a;border-radius:90px;display:flex;justify-content:center;align-items:center;border-bottom-left-radius:90px!important;border-bottom-right-radius:90px!important}", ""]);

// exports
